import { cloudProjectID, isCloudSite } from "../electron-modules";
import { withOriginalID } from "../export/utils/misc";
import { Bookmark } from "../redux/bookmarks-slice";
import { AerialViewState, SceneCameraState } from "../redux/camera-slice";
import { SettingsState } from "../redux/settings-slice";
import { engineCloudURL } from "../urls";

const createBookmark = async (bookmark: Bookmark) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/projects/${cloudProjectID}/bookmarks`;
    await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(withOriginalID(bookmark))
    });
  } catch(err) {
    console.error(err);
  }
};

interface UpdateOptions {
  name?: string,
  date?: string,
  position?: number[],
  visible?: boolean,
  visibleAssets?: string[],
  settings?: SettingsState,
  aerialState?: AerialViewState,
  sceneState?: SceneCameraState;
}

const updateBookmark = async (bookmarkID: string, options: UpdateOptions) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/bookmarks/${bookmarkID}`;
    await fetch(url, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(options)
    });
  } catch(err) {
    console.error(err);
  }
};

const deleteBookmark = async (bookmarkID: string) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/bookmarks/${bookmarkID}`;
    await fetch(url, {method: "DELETE"});
  } catch(err) {
    console.error(err);
  }
};

const actions = {
  create: createBookmark,
  delete: deleteBookmark,
  update: updateBookmark,
};

export default actions;